/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Aiflowformatsincluded3Inputs */

const en_aiflowformatsincluded3 = /** @type {(inputs: Aiflowformatsincluded3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} formats included in the package`)
};

const de_aiflowformatsincluded3 = /** @type {(inputs: Aiflowformatsincluded3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Formate im Paket inklusive`)
};

/**
* | output |
* | --- |
* | "{count} formats included in the package" |
*
* @param {Aiflowformatsincluded3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowformatsincluded3 = /** @type {((inputs: Aiflowformatsincluded3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowformatsincluded3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowformatsincluded3(inputs)
	return de_aiflowformatsincluded3(inputs)
});
export { aiflowformatsincluded3 as "aiFlowFormatsIncluded" }